import { Globe, ListChecks, Plus, Webhook, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button/Button';

interface EndpointsEmptyStateProps {
  onCreateClick: () => void;
}

const STEPS = [
  { key: 'url', icon: Globe },
  { key: 'events', icon: ListChecks },
  { key: 'notify', icon: Zap },
] as const;

export function EndpointsEmptyState({ onCreateClick }: EndpointsEmptyStateProps) {
  const { t } = useTranslation('webhooksModule');

  return (
    <div
      className="rounded-lg border border-dashed border-border bg-muted/20 px-6 py-8 sm:px-8"
      data-testid="webhooks-empty-state"
    >
      <div className="mx-auto flex max-w-sm flex-col items-center text-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-background border border-border">
          <Webhook className="h-5 w-5 text-muted-foreground" aria-hidden />
        </div>

        <h3 className="mt-3 text-base font-semibold text-foreground">{t('endpoints.emptyState.title')}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{t('endpoints.emptyState.description')}</p>

        <Button
          variant="primary"
          size="default"
          className="mt-5"
          onClick={onCreateClick}
          data-testid="create-first-webhook-button"
        >
          <Plus className="h-4 w-4" aria-hidden />
          {t('endpoints.createButton')}
        </Button>
      </div>

      <ul className="mx-auto mt-6 flex max-w-xl flex-col gap-2 border-t border-border/60 pt-5 sm:flex-row sm:justify-center sm:gap-6">
        {STEPS.map(({ key, icon: Icon }) => (
          <li key={key} className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
            <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
            <span>{t(`endpoints.emptyState.steps.${key}.title`)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
